import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnChanges, OnDestroy,
	Output,
	SimpleChanges,
	ViewChild
} from "@angular/core";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {ISelectableItem} from "../list.selection.item/list.item.component";
import {SearchBoxComponent} from "../../index";
import {LogCat, LogManager} from "../../../../log";

@UntilDestroy()
@Component({
	selector: "cp-list-selection",
	templateUrl: "./list.select.template.html",
	styleUrls: ['./list.select.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListSelectComponent implements OnChanges, AfterViewInit , OnDestroy{
	@Input() allData: ISelectableItem[];
	@Input() showAddAll:boolean;
	@Input() showAddAllOnBottom:boolean;
	@Input() showRemoveAll:boolean;
	@Input() showRemoveAllOnBottom:boolean;
	@Input() showAllButton:boolean;
	@Input() outerSearchMode:boolean;
	@Input() outerSearchTitle = 'Studies';
	@Input() iconsMode:boolean;
	@Input() collapsible:boolean;
	@Input() collapseIcon:string;
	@Input() title:string;
	@Input() translatedTitle:string;
	@Input() alwaysShowRemove:boolean;
	@Input() navigatable: boolean = true;


	@Output() public addItem: EventEmitter<ISelectableItem[]> = new EventEmitter();
	@Output() public removeItem: EventEmitter<ISelectableItem[]> = new EventEmitter();
	@Output() public collapseToggled: EventEmitter<boolean> = new EventEmitter();

	@ViewChild("searchBox",{static:false}) searchBox: SearchBoxComponent;

	public dictionary: any = {};
	public itemsListBound: ISelectableItem[];

	public searchText: string = "";
	public searchTerms: string[] = [];
	public searchResults: ISelectableItem[] = [];

	constructor(private cd:ChangeDetectorRef){
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (this.searchText) {
			this.searchItems(this.searchText);
		} else {
			this.itemsListBound = this.allData;
		}
	}

	public addAll(){
		this.addItem.emit(this.itemsListBound);
	}

	public removeAll(){
		this.removeItem.emit(this.itemsListBound);
	}

	public ngAfterViewInit() {
		this.searchBox.search.asObservable()
			.pipe(untilDestroyed(this))
			.subscribe(searchText => {
				this.searchItems(searchText);
			});
	}


	public addItemHandler(item: ISelectableItem) {
		this.addItem.emit([item]);
	}

	public removeItemHandler(item: ISelectableItem) {
		this.removeItem.emit([item]);
	}

	public itemClickHandler(item: ISelectableItem) {
	}

	public itemDoubleClickHandler(item: ISelectableItem) {
		if (item.selected) {
			this.removeItem.emit([item]);
		} else {
			this.addItem.emit([item]);
		}
	}

	public toggleItemsList() {
		this.resetSearch();
	}

	public toggleCollapse() {
		if (this.collapsible) {
			this.collapseToggled.emit();
		}
	}

	public trackByIndex(index: number) {
		return index;
	}

	public ngOnDestroy(): void {
	}

	public onSearchClear() {
		this.resetSearch();
		this.cd.markForCheck();
	}

	private searchItems(searchText: string) {
		let results: ISelectableItem[] = [];
		let filter: any;
		let searchTerms: string = searchText.trim();

		if (searchTerms !== "") {
			for (let i = 0; i < this.allData.length; i++) {
				let item: ISelectableItem = this.allData[i];
				filter = this.filter(item, searchTerms);
				if (filter) {
					results.push(this.allData[i]);
				}
			}
			this.searchText = searchTerms;
			this.searchTerms = searchTerms.split(' ');
			this.searchResults = results;
			this.itemsListBound = this.searchResults;
		} else {
			this.resetSearch();
		}

		this.cd.markForCheck();
	}

	private filter(item: ISelectableItem, value: string) {
		return item.description.toLowerCase().includes(value.toLowerCase());
	}

	private resetSearch() {
		this.itemsListBound = this.allData;
		this.searchText = "";
		this.searchTerms = [];
		this.searchResults = [];
	}
}
